import React from "react";

import "./project-card-component-styles.scss";

// importing icons
import { AiFillEye } from "react-icons/ai";

// importing components
import ButtonComponent from "../../components/button-component/button-component";

const ProjectCardComponent = ({
	title,
	type,
	description,
	imgSrc,
	projectNo,
	btnLink,
	lightColor,
	mediumColor,
	brightColor,
}) => {
	return (
		<div className="projects-container">
			<div
				style={{ background: `${lightColor}` }}
				className="project-card"
			>
				<div className="project-card-content">
					<span
						style={{
							background: `${mediumColor}`,
							border: `1px solid ${brightColor}`,
						}}
						className="project-type"
					>
						{type}
					</span>
					<h3 className="project-name">{title}</h3>
					<p className="project-description">{description}</p>
					<ButtonComponent
						icon={<AiFillEye />}
						text="View Project"
						btnLink={btnLink}
					/>
				</div>
				<div className="project-card-image-box">
					<img
						style={{
							background: `${mediumColor}`,
							border: `1px solid ${mediumColor}`,
							boxShadowColor: `${mediumColor}`,
						}}
						src={imgSrc}
						alt=""
						className="project-card-image"
					/>
					<span
						style={{
							color: `${mediumColor}`,
						}}
						className="project-number"
					>
						{projectNo}
					</span>
				</div>
			</div>
		</div>
	);
};

export default ProjectCardComponent;
